import React, { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { app } from './firebaseConfig';
import { locationDataFetchDelay } from './settings';

const FETCH_DELAY = locationDataFetchDelay;

const LocationAndSchedule = ({ event, embargoConfig }) => {
  const embargoCampsDate = embargoConfig?.embargoCampsDate ? new Date(embargoConfig.embargoCampsDate) : null;
  const embargoArtDate = embargoConfig?.embargoArtDate ? new Date(embargoConfig.embargoArtDate) : null;
  const [expanded, setExpanded] = useState(false);
  const [additionalData, setAdditionalData] = useState(null);
  const [loadingAdditionalData, setLoadingAdditionalData] = useState(false);
  const [error, setError] = useState(null);

  const db = getFirestore(app);

  useEffect(() => {
    setExpanded(false);
    setAdditionalData(null);
    setLoadingAdditionalData(false);
    setError(null);
  }, [event]);

  const handleExpand = () => {
    setExpanded(true);
    setLoadingAdditionalData(true);
    setError(null);
    setTimeout(async () => {
      await fetchAdditionalData(event);
      setLoadingAdditionalData(false);
    }, FETCH_DELAY * 1000);
  };

  const fetchAdditionalData = async (event) => {
    try {
      let additionalData = {};

      if (event.hosted_by_camp) {
        const campDoc = await getDoc(doc(db, 'camps', event.hosted_by_camp));
        if (campDoc.exists()) {
          const campData = campDoc.data();
          additionalData.camp = {
            name: campData.name,
            description: campData.description,
            location_string: campData.location_string,
            url: campData.url,
          };
        }
      }

      if (event.located_at_art) {
        const artDoc = await getDoc(doc(db, 'art', event.located_at_art));
        if (artDoc.exists()) {
          const artData = artDoc.data();
          additionalData.art = {
            name: artData.name,
            description: artData.description,
            location_string: artData.location_string,
            url: artData.url,
          };
        }
      }

      additionalData.schedule = event.occurrence_set;

      setAdditionalData(additionalData);
    } catch (error) {
      console.error('Error fetching additional data:', error);
      setError('Failed to load location and schedule.');
    }
  };

  const shouldEmbargo = (event, embargoDate) => {
    if (!embargoDate) return false;
    const now = new Date();
    const eventYear = new Date(event.occurrence_set[0].start_time).getFullYear();
    return now < embargoDate && eventYear === embargoDate.getFullYear();
  };

  return (
    <div>
      {!expanded && (
        <a href="#" onClick={(e) => { e.preventDefault(); handleExpand(); }}>
          Location & schedule
        </a>
      )}
      {expanded && (
        <div className="additional-info">
          {loadingAdditionalData && <p>Loading location and schedule...</p>}
          {error && <p className="error">{error}</p>}
          {additionalData && (
            <>
              {additionalData.camp && (
                <div>
                  <h3>
                    Hosted by Camp: {additionalData.camp.url ? (
                      <a href={additionalData.camp.url} target="_blank" rel="noopener noreferrer">
                        {additionalData.camp.name}
                      </a>
                    ) : (
                      additionalData.camp.name
                    )}
                  </h3>
                  <p>{additionalData.camp.description}</p>
                  <p>{shouldEmbargo(event, embargoCampsDate) ? `Camp locations will be visible on ${embargoCampsDate.toLocaleDateString()}` : `Location: ${additionalData.camp.location_string}`}</p>
                </div>
              )}
              {additionalData.art && (
                <div>
                  <h3>
                    Located at Art: {additionalData.art.url ? (
                      <a href={additionalData.art.url} target="_blank" rel="noopener noreferrer">
                        {additionalData.art.name}
                      </a>
                    ) : (
                      additionalData.art.name
                    )}
                  </h3>
                  <p>{additionalData.art.description}</p>
                  <p>{shouldEmbargo(event, embargoArtDate) ? `Art locations will be visible on ${embargoArtDate.toLocaleDateString()}` : `Location: ${additionalData.art.location_string}`}</p>
                </div>
              )}
              {additionalData.schedule  && (
                <>
                  <h3>Schedule:</h3>
                  <ul>
                    { additionalData.schedule.map((occurrence, index) => (
                      <li key={index}>
                        {new Date(occurrence.start_time).toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })} - {new Date(occurrence.end_time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationAndSchedule;
